/**
 * created by li si yi
 * 发布设置配置项
 */
export const publishInformationConfig = {
    modules: ['ygMedia']
};